export const getPublisherTypeName = {
  '1': 'Dueño Directo',
  '2': 'Inmobiliaria',
  '3': 'Constructora',
  '4': 'Corredor'
};

export const getContactModalPublisherType = publisherTypeId => {
  const publisherTypeEnabled = ['2', '3', '4'];
  return publisherTypeEnabled.includes(publisherTypeId);
};
